import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Warning = styled.div`
  margin-top: 10px;
  padding: 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.redLight};
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 5px;
  border: ${({ theme }) => `1px solid ${theme.palette.system.red}`};
`;

export const WarningTitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.red};
  margin-bottom: 5px;
`;
